import React, {useContext} from 'react';
import "./events.scss";
import { AppContext } from '../../services/translationContext';
import { InsightsSection } from '../../components/sections/insights/insights';
import { ClientStoriesSection } from '../../components/sections/client-stories/client-stories';
import { PageHero } from '../../components/page-hero/page-hero';
import { EventsSection } from '../../components/sections/events/events';
import SeoHelmet from '../../components/SeoHelmet';
import { useParams } from 'react-router-dom';

export const Events = () => {
  let { lang } = useParams();
  const { services: {TranslationsService} } = useContext(AppContext);
//   document.title = `${TranslationsService.labels(`menu.insights.label`)} | ${TranslationsService.getMainInfoCompany('name')}`;
// {TranslationsService.labels('events')}

  const pageTitle = `${TranslationsService.labels("events")} | ${TranslationsService.getMainInfoCompany("name")}`;
  const pageDescription = TranslationsService.labels("hero_sections.events.text");
  const pageUrl = `https://www.sydea.com/${lang}/insights/events`;

  const eventsSchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: TranslationsService.labels("menu.events.label"),
    description: pageDescription,
    url: pageUrl,
    inLanguage: lang === "it" ? "it-IT" : "en-US",
    publisher: {
      "@id": "https://www.sydea.com/#organization"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: `https://www.sydea.com/${lang}`
      },
      {
        "@type": "ListItem",
        position: 2,
        name: TranslationsService.labels("menu.insights.label"),
        item: `https://www.sydea.com/${lang}/insights`
      },
      {
        "@type": "ListItem",
        position: 3,
        name: TranslationsService.labels("menu.events.label"),
        item: pageUrl
      }
    ]
  };

  return (
    <div className="section-home light">
    <SeoHelmet
        title={pageTitle}
        description={pageDescription}
        image={TranslationsService.labels("hero_sections.events.img_path")}
        schema={[eventsSchema, breadcrumbSchema]}
    />
      {/* <PageHero
        bgImage={TranslationsService.labels('hero_sections.insights.img_path')}
        breadcrumb={[]}
        title={TranslationsService.labels(`menu.insights.label`)}
        subtitle={TranslationsService.labels(`hero_sections.insights.text`)}
        hideBreadcrumb={true}
      /> */}
      <div className='container pb-3'>
        <EventsSection />
      </div>
    </div>
  );
};
